import React, { useState } from "react";
import { Logo } from "./Logo";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Clients", href: "#clients" },
  { label: "Process", href: "#services" },
  { label: "Services", href: "#supplemental" },
  { label: "About", href: "#about" },
  { label: "Testimonials", href: "#testimonials" },
];

export const Navigation = () => {
  const [open, setOpen] = useState(false);
  return (
    <nav
      className="sticky top-0 z-50 backdrop-blur"
      style={{ background: "rgba(20,17,13,0.78)", borderBottom: "1px solid var(--bpm-line)" }}
      data-testid="main-nav"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo-link">
          <Logo size={36} />
        </a>
        <div className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="link-underline text-[14px] text-[color:var(--bpm-cream)]"
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
          <a href="#contact" className="btn" data-testid="nav-cta-contact">
            Get in Touch
          </a>
        </div>
        <button
          className="md:hidden p-2 rounded-full"
          style={{ border: "1px solid var(--bpm-line-strong)", color: "var(--bpm-cream)" }}
          onClick={() => setOpen((s) => !s)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>
      {open && (
        <div className="md:hidden" style={{ borderTop: "1px solid var(--bpm-line)" }} data-testid="mobile-menu">
          <div className="px-6 py-5 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[15px] text-[color:var(--bpm-cream)]"
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
              >
                {l.label}
              </a>
            ))}
            <a href="#contact" onClick={() => setOpen(false)} className="btn self-start" data-testid="mobile-nav-cta">
              Get in Touch
            </a>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navigation;
